import moment from 'moment';
import { isArray } from 'lodash';

// Archive-audit fix (2026-07-05): archiving writes a lead note whose `note` enum equals
// the archive reason (there is no dedicated ARCHIVED note type — see commons NOTE_CHOICES),
// and it is written as part of the archive flow. The "Archive note" column must show THAT
// note, not simply the most recent note (which can be any later annotation).
//
// Contract: returns the most recent note whose `note` matches reasonForArchiving, or null
// when there is no reason / no notes / no match — callers fall back to their legacy source.
// The backend now exposes `archive_note` (from the ArchiveRestoreRequest) and
// useLeadTableHelper prefers it; this selector remains the fallback for rows
// archived before the field shipped (their requests carry an empty note).
export function pickArchiveNote(leadNotes, reasonForArchiving) {
    if (!reasonForArchiving || !isArray(leadNotes) || leadNotes.length === 0) return null;
    const matches = leadNotes.filter((n) => n?.note === reasonForArchiving);
    if (matches.length === 0) return null;
    return [...matches].sort((a, b) =>
        moment(b.updated_at, 'DD-MM-YYYY HH:mm:ss.SSSSSSZ').diff(moment(a.updated_at, 'DD-MM-YYYY HH:mm:ss.SSSSSSZ'))
    )[0];
}

export default pickArchiveNote;
